import axios from 'axios'
import requestInterceptor from '../../requestInterceptor'
import responseInterceptor from '../../responseInterceptor'
import { cashDeskServiceUrl } from '../../../../urls'

const headers = {
	'Content-Type': 'application/json',
	'X-Requested-With': 'XMLHttpRequest',
}

const cashDeskInstance = axios.create({
	baseURL: cashDeskServiceUrl,
	headers,
})

cashDeskInstance.interceptors.request.use(requestInterceptor, error => Promise.reject(error))

cashDeskInstance.interceptors.response.use(response => response, error => {
	return responseInterceptor(error)
})

export default cashDeskInstance
